import React from 'react';

// Temporary diagnostic error boundary. Wrap a page in this to see the
// actual crash message on-screen instead of a blank page. Safe to leave
// in place — it only renders when a child throws.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: 'monospace' }}>
          <div className="alert-banner alert-danger" style={{ display: 'block' }}>
            <h3 style={{ marginBottom: 8 }}>This page hit an error</h3>
            <div style={{ fontSize: 13, marginBottom: 12 }}>
              The message below tells us what went wrong. Copy it and send it over.
            </div>
            <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, background: 'rgba(0,0,0,0.06)', padding: 12, borderRadius: 6 }}>
{String(this.state.error && this.state.error.toString())}
{this.state.info && this.state.info.componentStack ? '\n' + this.state.info.componentStack : ''}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
